import { render, staticRenderFns } from "./editIndividuation.vue?vue&type=template&id=18108ca2&scoped=true"
import script from "./editIndividuation.vue?vue&type=script&lang=js"
export * from "./editIndividuation.vue?vue&type=script&lang=js"
import style0 from "./editIndividuation.vue?vue&type=style&index=0&id=18108ca2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18108ca2",
  null
  
)

export default component.exports